import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import lookups from '@/assets/json/clientLookups.json'

export default async function () {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const authStore = useAuthStore()

  let { serviceId: serviceTransactionId } = router.currentRoute.value.params
  let { withException = '' } = router.currentRoute.value.query

  try {
    formStore.extraMap = {
      refundWhiteListCollection: [],
      administrativeRegionId: null,
      othersBeneficiaryType: 0,
      serviceTransactionId,
      lastRefundRequestPathStr: 'checkEligibilityForWhiteListRefund',
      showRefundTable: false,
      totalRefundableAmount: 0,
      withException: withException == 'true'
    }
  } catch (error) {
    console.error('use375Preload', error)
  }
}
